module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/step-2-buyback_07febce3a3ae217a24d83c994e8a18f3.png";